import { render, staticRenderFns } from "./TrainingItemFeedbackForm.vue?vue&type=template&id=2da9501b&"
import script from "./TrainingItemFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./TrainingItemFeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports